module.exports = __webpack_public_path__ + "img/24.c55bef7c.webp";